import clsx from "clsx";

// MUI
import { Button, CircularProgress, Input, Skeleton, Stack, Typography } from "@mui/material";

// Components
import NumericProgress from "@Layouts/components/Basics/NumericProgress";

export default function UploadDataWithTimerButton(props) {
	const {
		accept,
		className = "",
		disabled = false,
		loading = false,
		uploading = false,
		title = "Upload",
		titleSx = null,
		sx = null,
		labelSx = null,
		onChange = () => {},
		disableNumericProgress = false,
		disableCircularProgress = false,
	} = props;

	return (
		<label htmlFor="upload-data-button" style={labelSx}>
			<Input
				id="upload-data-button"
				multiple
				type="file"
				style={{ display: "none" }}
				disabled={disabled || uploading}
				inputProps={{ accept: accept || "*" }}
				onChange={onChange}
			/>
			<Button
				variant="contained"
				component="span"
				className={clsx({
					[className]: true,
				})}
				sx={sx}
				disabled={disabled || uploading}
			>
				{loading ? (
					<Skeleton variant="rectangular" height={30} width={140} sx={{ borderRadius: "6px" }} />
				) : (
					<>
						{uploading ? (
							<Stack direction={"row"} spacing={1}>
								{!disableCircularProgress && <CircularProgress color="inherit" size={20} />}
								{!disableNumericProgress && <NumericProgress color="inherit" size={20} />}
							</Stack>
						) : (
							<Typography className="btn-regular-text" sx={titleSx}>
								{title || "Upload"}
							</Typography>
						)}
					</>
				)}
			</Button>
		</label>
	);
}
